import React from 'react';
import { color as Color } from '@moda/tokens';

interface Props {
  selected: boolean;
}

export const LooksScrollStateSwitcher: React.FC<Props> = ({ selected }) => {
  const color = (selected ? Color('ink') : Color('fog')) ?? undefined;

  return (
    <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="10" height="20" fill={color} />
      <rect x="14" y="2" width="10" height="20" fill={color} />
      <rect x="26" y="2" width="10" height="20" fill={color} />
      <rect x="0.5" y="0.5" width="37" height="23" stroke={color} />
    </svg>
  );
};
